<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb :crumb="name"></breadcrumb>
          <div class="intro-wrapper main-x-spacing pb-2">
            <h2>{{ title }}</h2>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <v-col cols="10" class="body-middle-col pt-0">
                <div class="sectionTabs">
                  <v-tabs background-color="transparent" hide-slider>
                    <v-tab class="section-tab-header pt-6">
                      General Settings
                    </v-tab>
                    <!-- <v-tab class="section-tab-header">Menu</v-tab>
                    <v-tab class="section-tab-header">
                      Recipes & Sub Recipes
                    </v-tab>
                    <v-tab class="section-tab-header">Ingredients</v-tab>
                    <v-tab class="section-tab-header">Finished Goods</v-tab> -->
                  </v-tabs>
                  <hr class="my-5" />
                  <v-tabs-items class="section-tab-item">
                    <v-form ref="updateBrandForm">
                      <div class="form-group d-flex align-center">
                        <span class="label-spacing"> Name: </span>
                        <v-text-field
                          v-model="name"
                          hide-details
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field>
                      </div>
                      <div class="form-group d-flex align-start">
                        <span class="label-spacing"> Brand assigned to: </span>
                        <div class="all-tags">
                          <v-select
                            v-model="locations"
                            :items="enterpriseLocations"
                            item-text="locationName"
                            item-value="id"
                            hide-details
                            chips
                            multiple
                            flat
                            solo
                          ></v-select>
                        </div>
                      </div>
                      <div class="form-group d-flex align-center">
                        <span class="label-spacing"> Type: </span>
                        <div class="d-flex">
                          <v-checkbox
                            v-model="brandType"
                            class="text-center noSpaceCheckbox"
                            hide-details
                            color="accent"
                            value="owned"
                            label="Owned"
                          ></v-checkbox>
                          <v-checkbox
                            v-model="brandType"
                            class="text-center noSpaceCheckbox"
                            hide-details
                            color="accent"
                            value="franchise"
                            label="Franchise"
                          ></v-checkbox>
                        </div>
                      </div>
                      <div class="form-group d-flex">
                        <span class="label-spacing"> Brand Image: </span>

                        <div class="d-flex align-end">
                          <div
                            v-if="isSelected == false"
                            class="uploadHolder uploadPreview mb-2"
                          ></div>
                          <div v-if="isSelected == true">
                            <v-img
                              contain
                              class="uploadSrc"
                              max-height="300"
                              max-width="300"
                              :src="url"
                            ></v-img>
                          </div>

                          <div>
                            <div class="">
                              <div class="uploadButtonWrapper v-btn">
                                <v-file-input
                                  v-model="image"
                                  @change="previewImage"
                                  @click:clear="clearSelected"
                                  color="black"
                                  hide-details
                                  placeholder="Upload File"
                                  class="text-capitalize uploadButton"
                                  flat
                                  solo
                                  prepend-icon="undefined"
                                  prepend-inner-icon="publish"
                                  :rules="[rules.required]"
                                >
                                  <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">
                                      {{ text }}
                                    </v-chip>
                                  </template>
                                </v-file-input>
                              </div>

                              <span class="ml-4">No File Chosen</span>
                            </div>
                            <p class="caption">
                              Accepts JPG and PNG files only.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="form-group d-flex align-center">
                        <span class="label-spacing"> </span>
                        <v-btn
                          :ripple="false"
                          depressed
                          width="17%"
                          :loading="saveLoader"
                          large
                          class="success gen-button white--text mt-2"
                          @click="updateBrand"
                        >
                          <span>Save</span>
                        </v-btn>
                      </div>
                    </v-form>
                  </v-tabs-items>
                </div>
              </v-col>
              <v-col cols="2" class="col-2-side-tab col-2-side-tab-right">
                <div class="side-tab-child">
                  <h4>Don't Click unless you know are doing!!!</h4>
                  <v-btn
                    :ripple="false"
                    depressed
                    width="100%"
                    :loading="deleteLoader"
                    large
                    class="gen-button btn-outlined no-Btn-bg"
                    @click="deleteBrand"
                  >
                    <span>Delete</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      title: "",
      dataReady: false,
      brandId: this.$route.params.brandId,
      saveLoader: false,
      deleteLoader: false,
      name: "",
      locations: "",
      brandType: "",
      image: [], // must be an array
      isSelected: false,
      url: "",
      origUrl: "",
      rules: {
        required: (value) => !!value || "Required",
      },
    };
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
  methods: {
    getBrandDetails() {
      axios
        .get("/api/v1/brand/" + this.brandId, {
          headers: { Authorization: this.$store.state.token },
        })
        .then((response) => {
          this.dataReady = true;

          const data = response.data.data;

          // Data
          this.title = data.brandName;
          this.name = data.brandName;
          this.brandType = data.brandType;
          this.url = data.brandImage;
          this.locations = data.locations;
          this.origUrl = data.brandImage;

          // Make image preview show if image exists
          this.url.length > 5
            ? (this.isSelected = true)
            : (this.isSelected = false);
        })
        .catch(() => {});
    },
    previewImage() {
      if (this.image) {
        this.isSelected = true;
        this.url = URL.createObjectURL(this.image);
      }
    },
    clearSelected() {
      this.image = [];
      this.url = this.origUrl;
    },
    testUpload() {
      this.isSelected = !this.isSelected;
      this.url = "";
    },
    updateBrand() {
      if (this.$refs.updateBrandForm.validate()) {
        this.saveLoader = true;

        const brand = new FormData();

        // Formdata hack for appending array
        let locations = this.locations;
        locations.forEach((location) => {
          if (typeof location == "object") {
            brand.append("locations[]", location.id);
          } else if (typeof location == "number") {
            brand.append("locations[]", location);
          }
        });

        brand.append("brandName", this.name);
        brand.append("brandType", this.brandType);

        // Append Image if it exists

        if (this.image.length != 0) {
          brand.append("brandImage", this.image);
        }
        axios
          .put("/api/v1/brand/" + this.brandId, brand, {
            headers: { Authorization: this.$store.state.token },
          })
          .then(() => {
            this.saveLoader = false;

            setTimeout(() => {
              this.$router.push("/brands");
            }, 1000);
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
    deleteBrand() {
      if (this.$refs.updateBrandForm.validate()) {
        this.deleteLoader = true;

        axios
          .delete("/api/v1/brand/" + this.brandId, {
            headers: { Authorization: this.$store.state.token },
          })
          .then(() => {
            this.dataReady = false; //just to show the pre-laoder for a sec
            setTimeout(() => {
              this.$router.push("/brands");
              this.deleteLoader = false;
            }, 500);
          })
          .catch(() => {
            this.deleteLoader = false;
          });
      }
    },
    previewImageSelected() {
      this.url = URL.createObjectURL(this.image);
    },
  },
  created() {
    this.getBrandDetails();
  },
  computed: {
    ...mapState(["mainNav", "subCategories", "enterpriseLocations"]),
  },
};
</script>

<style scoped>
.flex3-div,
.flex2-div {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.created-tags-div {
  margin-top: 4%;
}

.tag-btn {
  margin-right: 1%;
  margin-top: 1%;
}

.tag-name {
  text-transform: capitalize;
}

.tag-icon {
  color: black;
  font-size: 12px;
}

.all-tags {
  border: 1px solid lightgrey;
  flex: auto;
}

.form-group {
  margin-bottom: 14px;
}

.form-group .label-spacing {
  width: 18%;
  text-align: right;
}

.uploadPreview {
  width: 300px;
  height: 300px;
}
</style>
